import { AllRows, Columns, ReportData } from '../result.interface';

export function getFileExportEventosEvaluacionCIPIA(ctx: any, vrs: number): any {

    var rs = ctx.eC; //ctx.reportService.eC;

    var cont = 1;
    for (let clave in rs){
        console.log(clave);
        if (clave == 'Fecha') { console.log('Si es Fecha'); };
        if (clave == 'FechaServidor') { console.log('Si es FechaServidor'); };

        if (clave == 'Parametros') { console.log('Si es parametros'); };

        console.log(rs[clave]);
        if (rs[clave]) {
            cont = cont +1;
            if (ctx.chkDateHour && clave == 'Fecha') { cont = cont +1; }
            if (ctx.chkDateHour && clave == 'FechaServidor') { cont = cont +1; }
            if (clave == 'EnlaceArchivo') { cont = cont +1; }
            if (clave == 'Parametros') { cont = cont - 1; }

        }
    }

    console.log("cont = "+ cont);



    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[];
    //var table_width = 12 + (ctx.chkDateHour? 2: 1) +1 + (ctx.user_id == 923? -2: 0);
    var table_width = cont;

    var vehiculo_width = (ctx.chkDateHour? 5: 4) +1 + (ctx.user_id == 923? -2: 0);

    // var feha_evento_cell_ch_width = "Fecha Evento".length;
    // var hora_evento_cell_ch_width = "Hora Evento".length;

    // var feha_servidor_cell_ch_width = "Fecha Servidor".length;
    // var hora_servidor_cell_ch_width = "Hora Servidor".length;

    var nombre_evento_cell_ch_width = "Nombre del Evento".length;
    var evento_cell_ch_width = "Evento".length;
    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;
    var tipo_unidad_cell_ch_width = "Tipo unidad".length;

    var id_conductor_cell_ch_width = "Id Conductor".length;
    var conductor_cell_ch_width = "Conductor".length;

    // var fecha_evaluacion_cell_ch_width = "Fecha de Evaluación".length;
    var criterio_evaluacion_cell_ch_width = "Criterio de Evaluación".length;

    var observacion_cell_ch_width = "Observación".length;
    // var validacion_cell_ch_width = "Validación".length;
    var has_radio_communication = "Comunicación Radial".length;

    var vel_can_cell_ch_width = "vel.CAN".length;
    var vel_gps_cell_ch_width = "vel.GPS".length;
    var vel_gps_speed_cell_ch_width = "vel.GPS speed".length;
    var vel_mobileye_cell_ch_width = "vel.Mobileye".length;
    var vel_eco_cell_ch_width = "vel.ECO".length;

    var zona_cell_ch_width = "Geocerca".length;
    var pc_cell_ch_width = "Punto Cercano".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;
    var referencia_cell_ch_width = "Referencia".length;
    var enlace_cell_ch_width = "Archivo".length; //Enlace a Archivo
    // var parametros_cell_ch_width = "Parámetros".length; //Enlace a Archivo
    var operador_monitoreo_cell_ch_width = "Operador de Monitoreo".length; //Enlace a Archivo


    // var allRows = [
    var allRows: AllRows[] = [
        {
          cells: [
            { value: ctx.report_data.rep_title+" "+ctx.str_nombre_eventos, ...ctx.headerCellConfig, colSpan: table_width }
          ],
          height: ctx.headerRowsHeight
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];

    ctx.data.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
          {
            cells: [
              //{ value: "REPORTE DE ATENCION DE EVENTOS CIPIA.", ...ctx.headerCellConfig, colSpan: table_width }
              { value: ctx.report_data.rep_title+" "+ctx.str_nombre_eventos, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              // { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              // { value: "PERIODO", ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width }
              { value: "PERIODO", ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width }
            ],
            height: ctx.subHeaderHeight
          },
          {
            cells: [
              // { value: data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              // { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
              { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width },
            ],
            height: ctx.subHeaderContentHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        ];

        //if(ctx.chkDateHour) {

          var array_campos_cabecera = [];

          array_campos_cabecera.push({ value: "Item", ...ctx.colHeaderConfig });

          if (!ctx.chkDateHour && rs.Fecha) { array_campos_cabecera.push({ value: "Fecha/Hora Evento", ...ctx.colHeaderConfig }); }
          if (ctx.chkDateHour && rs.Fecha) {  array_campos_cabecera.push({ value: "Fecha Evento", ...ctx.colHeaderConfig }); };
          if (ctx.chkDateHour && rs.Fecha) {  array_campos_cabecera.push({ value: "Hora Evento", ...ctx.colHeaderConfig }); };

          if (!ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { array_campos_cabecera.push({ value: "Fecha/Hora Servidor", ...ctx.colHeaderConfig }); }
          if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) {  array_campos_cabecera.push({ value: "Fecha Servidor", ...ctx.colHeaderConfig }); };
          if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) {  array_campos_cabecera.push({ value: "Hora Servidor", ...ctx.colHeaderConfig }); };

          if (rs.NombreEvento) { array_campos_cabecera.push({ value: "Nombre del Evento", ...ctx.colHeaderConfig }); };
          if (rs.Evento) { array_campos_cabecera.push({ value: "Descripción", ...ctx.colHeaderConfig }); };
          if (rs.Codigo) { array_campos_cabecera.push({ value: "Código", ...ctx.colHeaderConfig }); };
          if (rs.Placa) { array_campos_cabecera.push({ value: "Placa", ...ctx.colHeaderConfig }); };
          if (rs.TipoUnidad) { array_campos_cabecera.push({ value: "Tipo de Unidad", ...ctx.colHeaderConfig }); };

          if (rs.IdConductor) { array_campos_cabecera.push({ value: "ID Conductor", ...ctx.colHeaderConfig }); };
          if (rs.Conductor) { array_campos_cabecera.push({ value: "Conductor", ...ctx.colHeaderConfig }); };

          if (!ctx.chkDateHour && rs.FechaEvaluacion) { array_campos_cabecera.push({ value: "Fecha/Hora de Evaluación", ...ctx.colHeaderConfig }); }
          if (ctx.chkDateHour && rs.FechaEvaluacion) {  array_campos_cabecera.push({ value: "Fecha de Evaluación", ...ctx.colHeaderConfig }); };
          if (ctx.chkDateHour && rs.FechaEvaluacion) {  array_campos_cabecera.push({ value: "Hora de Evaluación", ...ctx.colHeaderConfig }); };

          if (rs.CriterioEvaluacion) { array_campos_cabecera.push({ value: "Criterio de Evaluación", ...ctx.colHeaderConfig }); };
          if (rs.Observacion) { array_campos_cabecera.push({ value: "Observación", ...ctx.colHeaderConfig }); };
          // if (rs.Validacion) { array_campos_cabecera.push({ value: "Validación", ...ctx.colHeaderConfig }); };
          if (rs.ComRadial) { array_campos_cabecera.push( { value: "Comunicación Radial", ...ctx.colHeaderConfig} ); };
          if (rs.VelMobileye) { array_campos_cabecera.push({ value: "Vel.Mobileye", ...ctx.colHeaderConfig }); };
          if (rs.VelGPS) { array_campos_cabecera.push({ value: "Vel.GPS", ...ctx.colHeaderConfig }); };
          if (rs.VelGPSspeed) { array_campos_cabecera.push({ value: "Vel.GPS speed", ...ctx.colHeaderConfig }); };
          if (rs.VelCAN) { array_campos_cabecera.push({ value: "Vel.CAN", ...ctx.colHeaderConfig }); };
          if (rs.VelECO) { array_campos_cabecera.push({ value: "Vel.ECO", ...ctx.colHeaderConfig }); };

          if (rs.Zona) { array_campos_cabecera.push({ value: "Geocerca", ...ctx.colHeaderConfig }); };
          if (rs.PuntoCercano) { array_campos_cabecera.push({ value: "Punto Cercano", ...ctx.colHeaderConfig }); };
          if (rs.Ubicacion) { array_campos_cabecera.push({ value: "Ubicación", ...ctx.colHeaderConfig }); };
          if (rs.Referencia) { array_campos_cabecera.push({ value: "Referencia", ...ctx.colHeaderConfig }); };
          if (rs.EnlaceArchivo) { array_campos_cabecera.push({ value: "Enlace a Archivo", colSpan: 2, ...ctx.colHeaderConfig }); };
          // if (rs.Parametros) { array_campos_cabecera.push({ value: "Parámetros", ...ctx.colHeaderConfig }); };
          if (rs.OperadorMonitoreo) { array_campos_cabecera.push({ value: "Operador de Monitoreo", ...ctx.colHeaderConfig }); };

            var array_campos_cuerpo= [];


          rows.push({
            cells: array_campos_cabecera ,height: ctx.colsHeaderHeight
          });


          data[1].forEach((item: {fecha_evaluacion:any, operador_monitoreo:any, ComRadial:any, nombre_evento:any, observacion_evaluacion:any, criterio_evaluacion:any, parametros:any, vel_eco:any, vel_gps_speed:any, vel_mobileye:any, referencia:any, enlaceVideoCIPIA:any, enlaceImageCIPIA:any, descripcion_evento:any; fecha_tracker: number; fecha_servidor: number;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; vel_gps: any; vel_can: any; tramo: string; PC: any; sonidoEnCabina: any;}, index: number) => {

              //var fh = item.fecha.split(" ");
              var ubicacion_url = item.latitud + "," + item.longitud;
              var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6);

              nombre_evento_cell_ch_width = Math.max(nombre_evento_cell_ch_width, (item.nombre_evento??'').toString().length);
              evento_cell_ch_width = Math.max(evento_cell_ch_width, (item.descripcion_evento??'').toString().length);
              codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
              placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
              tipo_unidad_cell_ch_width = Math.max(tipo_unidad_cell_ch_width, (item.tipo_unidad??'').toString().length);


              id_conductor_cell_ch_width = Math.max(id_conductor_cell_ch_width, (item.idConductor??'').toString().length);
              conductor_cell_ch_width = Math.max(conductor_cell_ch_width, (item.conductor??'').toString().length);


              criterio_evaluacion_cell_ch_width = Math.max(criterio_evaluacion_cell_ch_width, (item.criterio_evaluacion??'').toString().length);

              observacion_cell_ch_width = Math.max(observacion_cell_ch_width, (item.observacion_evaluacion??'').toString().length);
              has_radio_communication = Math.max(has_radio_communication, (item.ComRadial??'').toString().length);;

              vel_mobileye_cell_ch_width = Math.max(vel_mobileye_cell_ch_width, (item.vel_mobileye??'').toString().length);
              vel_gps_cell_ch_width = Math.max(vel_gps_cell_ch_width, (item.vel_gps??'').toString().length);
              vel_gps_speed_cell_ch_width = Math.max(vel_gps_speed_cell_ch_width, (item.vel_gps_speed??'').toString().length);
              vel_can_cell_ch_width = Math.max(vel_can_cell_ch_width, (item.vel_can??'').toString().length);
              vel_eco_cell_ch_width = Math.max(vel_eco_cell_ch_width, (item.vel_eco??'').toString().length);

              zona_cell_ch_width = Math.max(zona_cell_ch_width, (item.tramo??'').toString().length);
              pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);
              ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
              referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
              enlace_cell_ch_width = Math.max(enlace_cell_ch_width, (ubicacion??'').toString().length);
              // parametros_cell_ch_width = Math.max(parametros_cell_ch_width, (item.parametros??'').toString().length);


              var array_campos_cuerpo= [];

              array_campos_cuerpo.push({ value: (index + 1), ...ctx.bodyRowsConfig });

              if (!ctx.chkDateHour && rs.Fecha) { array_campos_cuerpo.push({ value: ctx.isChe(item.fecha_tracker), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig }); };
              if (ctx.chkDateHour && rs.Fecha) { array_campos_cuerpo.push({ value: ctx.isChe(item.fecha_tracker), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig }); }
              if (ctx.chkDateHour && rs.Fecha) { array_campos_cuerpo.push({ value: ctx.isChs(item.fecha_tracker), format: "hh:mm:ss", ...ctx.bodyRowsConfig }); };

              if (!ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { array_campos_cuerpo.push({ value: ctx.isChe(item.fecha_servidor), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig }); };
              if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { array_campos_cuerpo.push({ value: ctx.isChe(item.fecha_servidor), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig }); };
              if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { array_campos_cuerpo.push({ value: ctx.isChs(item.fecha_servidor), format: "hh:mm:ss", ...ctx.bodyRowsConfig }); };
              
              if (rs.NombreEvento) { array_campos_cuerpo.push({ value: item.nombre_evento, ...ctx.bodyRowsConfig }); };
              if (rs.Evento) { array_campos_cuerpo.push({ value: item.descripcion_evento, ...ctx.bodyRowsConfig }); };
              if (rs.Codigo) { array_campos_cuerpo.push({ value: item.codigo, ...ctx.bodyRowsConfig }); };
              if (rs.Placa) { array_campos_cuerpo.push({ value: item.placa, ...ctx.bodyRowsConfig }); };
              if (rs.TipoUnidad) { array_campos_cuerpo.push({ value: item.tipo_unidad, ...ctx.bodyRowsConfig }); };

              if (rs.IdConductor) { array_campos_cuerpo.push({ value: item.idConductor, ...ctx.bodyRowsConfig }); };
              if (rs.Conductor) { array_campos_cuerpo.push({ value: item.conductor, ...ctx.bodyRowsConfig }); };


              var f1 = '';
              var f2 = '';
              if (item.fecha_evaluacion != null) {
                f1 = ctx.isChe(item.fecha_evaluacion);
                f2 = ctx.isChs(item.fecha_evaluacion);
              }

              if (!ctx.chkDateHour && rs.FechaEvaluacion) { array_campos_cuerpo.push({ value: ctx.isChe(item.fecha_evaluacion), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig }); };
              if (ctx.chkDateHour && rs.FechaEvaluacion) { array_campos_cuerpo.push({ value: f1, format: "yyyy/mm/dd", ...ctx.bodyRowsConfig }); }
              if (ctx.chkDateHour && rs.FechaEvaluacion) { array_campos_cuerpo.push({ value: f2, format: "hh:mm:ss", ...ctx.bodyRowsConfig }); };


              if (rs.CriterioEvaluacion) { array_campos_cuerpo.push({ value: item.criterio_evaluacion, ...ctx.bodyRowsConfig }); };
              if (rs.Observacion) { array_campos_cuerpo.push({ value: item.observacion_evaluacion, ...ctx.bodyRowsConfig }); };
              if (rs.ComRadial) { array_campos_cuerpo.push( { value: item.ComRadial, ...ctx.bodyRowsConfig} ); };
              if (rs.VelMobileye) { array_campos_cuerpo.push({ value: item.vel_mobileye +"", ...ctx.bodyRowsConfig }); };
              if (rs.VelGPS) { array_campos_cuerpo.push({ value: item.vel_gps +"", ...ctx.bodyRowsConfig }); };
              if (rs.VelGPSspeed) { array_campos_cuerpo.push({ value: item.vel_gps_speed +"", ...ctx.bodyRowsConfig }); };
              if (rs.VelCAN) { array_campos_cuerpo.push({ value: item.vel_can +"", ...ctx.bodyRowsConfig }); };
              if (rs.VelECO) { array_campos_cuerpo.push({ value: item.vel_eco +"", ...ctx.bodyRowsConfig }); };

              if (rs.Zona) { array_campos_cuerpo.push({ value: item.tramo, ...ctx.bodyRowsConfig }); };
              if (rs.PuntoCercano) { array_campos_cuerpo.push({ value: item.PC, ...ctx.bodyRowsConfig }); };
              //if (rs.Ubicacion) { array_campos_cuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig }); };
              if (rs.Ubicacion) { array_campos_cuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion_url+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig, fontSize: ctx.c1_2 }); };

              if (rs.Referencia) { array_campos_cuerpo.push({ value: item.referencia, ...ctx.bodyRowsConfig }); };
              if (rs.EnlaceArchivo) {
                  array_campos_cuerpo.push({ formula: 'HYPERLINK("'+item.enlaceImageCIPIA+'","Imagen")', color:'#0000FF', ...ctx.bodyRowsConfig });
                  array_campos_cuerpo.push({ formula: 'HYPERLINK("'+item.enlaceVideoCIPIA+'","Video")', color:'#0000FF', ...ctx.bodyRowsConfig });   };

              // if (rs.Parametros) { array_campos_cuerpo.push({ value: item.parametros, ...ctx.bodyRowsConfig }); };
              if (rs.OperadorMonitoreo) { array_campos_cuerpo.push({ value: item.operador_monitoreo, ...ctx.bodyRowsConfig }); };




              rows.push({
                cells: array_campos_cuerpo, height: ctx.bodyRowsHeight
              });

          });

        //}

        // //********************************************* excel version 1 *********************************
    if (vrs == 1) {

      column_config = [ { width: ctx.w_item }  ];

      if (!ctx.chkDateHour && rs.Fecha) {  column_config.push( { width: ctx.w_date_and_hour } );  };
      if (ctx.chkDateHour && rs.Fecha) { column_config.push( { width: ctx.w_date } );  }
      if (ctx.chkDateHour && rs.Fecha) { column_config.push( { width: ctx.w_hour } );  }

      if (!ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) {  column_config.push( { width: ctx.w_date_and_hour } );  };
      if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { column_config.push( { width: ctx.w_date } );  }
      if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { column_config.push( { width: ctx.w_hour } );  }


      if (rs.NombreEvento) {  column_config.push( { width: ctx.calculateColWidth(nombre_evento_cell_ch_width) }  );  };
      if (rs.Evento) {  column_config.push( { width: ctx.calculateColWidth(evento_cell_ch_width) }  );  };
      if (rs.Codigo) {  column_config.push( { width: ctx.calculateColWidth(codigo_cell_ch_width) }  );  };
      if (rs.Placa)  {  column_config.push( { width: ctx.calculateColWidth(placa_cell_ch_width) }  );  };
      if (rs.TipoUnidad) { column_config.push( { width: ctx.calculateColWidth(tipo_unidad_cell_ch_width) }  );  };


      if (rs.IdConductor) { column_config.push( { width: ctx.calculateColWidth(id_conductor_cell_ch_width) }  ); };
      if (rs.Conductor) {   column_config.push( { width: ctx.calculateColWidth(conductor_cell_ch_width) }  ); };

      if (!ctx.chkDateHour && rs.FechaEvaluacion) {  column_config.push( { width: ctx.w_date_and_hour } );  };
      if (ctx.chkDateHour && rs.FechaEvaluacion)  { column_config.push( { width: ctx.w_date } );  };
      if (ctx.chkDateHour && rs.FechaEvaluacion) { column_config.push( { width: ctx.w_hour } );  };

      if (rs.CriterioEvaluacion) { column_config.push( { width: ctx.calculateColWidth(criterio_evaluacion_cell_ch_width) }  ); };
      if (rs.Observacion) { column_config.push( { width: ctx.calculateColWidth(observacion_cell_ch_width) }  ); };

      if (rs.ComRadial ) { column_config.push( {width: ctx.calculateColWidth(has_radio_communication)} ); };

      if (rs.VelMobileye) { column_config.push( { width: ctx.calculateColWidth(vel_mobileye_cell_ch_width) }  ); };
      if (rs.VelGPS) { column_config.push( { width: ctx.calculateColWidth(vel_gps_cell_ch_width) }  ); };
      if (rs.VelGPSspeed) { column_config.push( { width: ctx.calculateColWidth(vel_gps_speed_cell_ch_width) }  ); };
      if (rs.VelCAN) { column_config.push( { width: ctx.calculateColWidth(vel_can_cell_ch_width) }  ); };
      if (rs.VelECO) { column_config.push( { width: ctx.calculateColWidth(vel_eco_cell_ch_width) }  ); };

      if (rs.Zona) { column_config.push( { width: ctx.calculateColWidth(zona_cell_ch_width) }  ); };
      if (rs.PuntoCercano) { column_config.push( { width: ctx.calculateColWidth(pc_cell_ch_width) }  ); };
      if (rs.Ubicacion) { column_config.push( { width: ctx.calculateColWidth(ubicacion_cell_ch_width) }  ); };
      if (rs.Referencia) { column_config.push( { width: ctx.calculateColWidth(referencia_cell_ch_width) }  ); };
      if (rs.EnlaceArchivo) { column_config.push( { width: ctx.calculateColWidth(placa_cell_ch_width) }  );  };
      if (rs.EnlaceArchivo) { column_config.push( { width: ctx.calculateColWidth(placa_cell_ch_width) }  );  };

      // if (rs.Parametros) { column_config.push( { width: ctx.calculateColWidth(parametros_cell_ch_width) }  );  };
      if (rs.OperadorMonitoreo) { column_config.push( { width: ctx.calculateColWidth(operador_monitoreo_cell_ch_width) }  );  };


      exportFileEx.push({
      freezePane: {
        rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
        },
      columns: column_config,
      title: data[0][1],
      rows: rows
      });


      nombre_evento_cell_ch_width = "Nombre del Evento".length;
      evento_cell_ch_width = "Evento".length;
      codigo_cell_ch_width = "codigo".length;
      placa_cell_ch_width = "placa".length;
      tipo_unidad_cell_ch_width = "Tipo unidad".length;

      id_conductor_cell_ch_width = "Id Conductor".length;
      conductor_cell_ch_width = "Conductor".length;

      // fecha_evaluacion_cell_ch_width = "Fecha de Evaluación".length;
      criterio_evaluacion_cell_ch_width = "Criterio de Evaluación".length;

      observacion_cell_ch_width = "Observación".length;
      // validacion_cell_ch_width = "Validación".length;
      has_radio_communication = "Comunicación Radial".length

      vel_mobileye_cell_ch_width = "vel.Mobileye".length;
      vel_gps_cell_ch_width = "vel.GPS".length;
      vel_gps_speed_cell_ch_width = "vel.GPS speed".length;
      vel_can_cell_ch_width = "vel.CAN".length;
      vel_eco_cell_ch_width = "vel.ECO".length;

      zona_cell_ch_width = "Zona".length;
      pc_cell_ch_width = "Punto Cercano".length;
      ubicacion_cell_ch_width = "Ubicacion".length;
      referencia_cell_ch_width = "Referencia".length;
      enlace_cell_ch_width = "Enlace a Archivo".length; //Enlace a Archivo
      // parametros_cell_ch_width = "Parametros".length; //Enlace a Archivo
      operador_monitoreo_cell_ch_width = "Operador de Monitoreo".length; //Enlace a Archivo


    }
    // //********************************************* excel version 1 *********************************

    // //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      rows.splice(0, ctx.headerRowSpan);
      rows.push(...ctx.spaceBetweenTables);
      allRows = allRows.concat(rows);
    }
    // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
        allRows[0].cells![0].colSpan = table_width;


        column_config = [ { width: ctx.w_item }  ];

        if (!ctx.chkDateHour && rs.Fecha) {  column_config.push( { width: ctx.w_date_and_hour } );  };
        if (ctx.chkDateHour && rs.Fecha) { column_config.push( { width: ctx.w_date } );  }
        if (ctx.chkDateHour && rs.Fecha) { column_config.push( { width: ctx.w_hour } );  }

        if (!ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) {  column_config.push( { width: ctx.w_date_and_hour } );  };
        if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { column_config.push( { width: ctx.w_date } );  };
        if (ctx.chkDateHour && ctx.user_id != 923 && rs.FechaServidor) { column_config.push( { width: ctx.w_hour } );  };


        if (rs.NombreEvento) {  column_config.push( { width: ctx.calculateColWidth(nombre_evento_cell_ch_width) }  );  };
        if (rs.Evento) {  column_config.push( { width: ctx.calculateColWidth(evento_cell_ch_width) }  );  };
        if (rs.Codigo) {  column_config.push( { width: ctx.calculateColWidth(codigo_cell_ch_width) }  );  };
        if (rs.Placa)  {  column_config.push( { width: ctx.calculateColWidth(placa_cell_ch_width) }  );  };
        if (rs.TipoUnidad) { column_config.push( { width: ctx.calculateColWidth(tipo_unidad_cell_ch_width) }  );  };

        if (rs.IdConductor) { column_config.push( { width: ctx.calculateColWidth(id_conductor_cell_ch_width) }  ); };
        if (rs.Conductor) {   column_config.push( { width: ctx.calculateColWidth(conductor_cell_ch_width) }  ); };

        if (!ctx.chkDateHour && rs.FechaEvaluacion) {  column_config.push( { width: ctx.w_date_and_hour } );  };
        if (ctx.chkDateHour && rs.FechaEvaluacion)  { column_config.push( { width: ctx.w_date } );  };
        if (ctx.chkDateHour && rs.FechaEvaluacion) { column_config.push( { width: ctx.w_hour } );  };

        if (rs.CriterioEvaluacion) { column_config.push( { width: ctx.calculateColWidth(criterio_evaluacion_cell_ch_width) }  ); };
        if (rs.Observacion) { column_config.push( { width: ctx.calculateColWidth(observacion_cell_ch_width) }  ); };

        if (rs.ComRadial) { column_config.push( {width: ctx.calculateColWidth(has_radio_communication)} ); };

        if (rs.VelMobileye) { column_config.push( { width: ctx.calculateColWidth(vel_mobileye_cell_ch_width) }  ); };
        if (rs.VelGPS) { column_config.push( { width: ctx.calculateColWidth(vel_gps_cell_ch_width) }  ); };
        if (rs.VelGPSspeed) { column_config.push( { width: ctx.calculateColWidth(vel_gps_speed_cell_ch_width) }  ); };
        if (rs.VelCAN) { column_config.push( { width: ctx.calculateColWidth(vel_can_cell_ch_width) }  ); };
        if (rs.VelECO) { column_config.push( { width: ctx.calculateColWidth(vel_eco_cell_ch_width) }  ); };

        if (rs.Zona) { column_config.push( { width: ctx.calculateColWidth(zona_cell_ch_width) }  ); };
        if (rs.PuntoCercano) { column_config.push( { width: ctx.calculateColWidth(pc_cell_ch_width) }  ); };
        if (rs.Ubicacion) { column_config.push( { width: ctx.calculateColWidth(ubicacion_cell_ch_width) }  ); };
        if (rs.Referencia) { column_config.push( { width: ctx.calculateColWidth(referencia_cell_ch_width) }  ); };
        if (rs.EnlaceArchivo) { column_config.push( { width: ctx.calculateColWidth(placa_cell_ch_width) }  );  };
        if (rs.EnlaceArchivo) { column_config.push( { width: ctx.calculateColWidth(placa_cell_ch_width) }  );  };

        // if (rs.Parametros) { column_config.push( { width: ctx.calculateColWidth(parametros_cell_ch_width) }  );  };
        if (rs.OperadorMonitoreo) { column_config.push( { width: ctx.calculateColWidth(operador_monitoreo_cell_ch_width) }  );  };




      exportFileEx.push({
        freezePane: {
          rowSplit: ctx.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log("===>exportFileEx getFileExportEventosEvaluacionCIPIA", exportFileEx);  
        
    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }

  }